import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { quoteFormSelector } from 'ctm-selectors';
import { formatAddress } from 'ctm-components/components/address/utils';
import { SummaryTable } from '../summary_table';
import { getParkingTypeLabel } from '../../products/summary/common/details/address';

const path = 'car_address';

const _SummaryOvernightAddress = (props) => {
    const { overnightParkingType, buildingName, unitType, unitNumber, streetNumber, streetName, suburb, overnightParkingPostcode, ausState, isUpdated } = props;

    const overnightParking = [
        {
            title: 'Address',
            value: formatAddress({ buildingName, unitType, unitNumber, streetNumber, streetName, suburb, overnightParkingPostcode, ausState })
        },
        {
            title: 'Vehicle parking',
            value: getParkingTypeLabel(overnightParkingType)
        }
    ];

    return (
        <SummaryTable
            isUpdated={isUpdated}
            path={path}
            titleLabel={`Overnight Parking Address ${isUpdated ? '- Updated' : ''}`}
            tableContent={overnightParking}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        buildingName: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'buildingName']),
        unitType: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'unitType']),
        unitNumber: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'unitNumber']),
        streetNumber: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'streetNumber']),
        streetName: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'streetName']),
        suburb: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'suburb']),
        ausState: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'state']),
        overnightParkingPostcode: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'postcode']),
        overnightParkingType: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'parkingType']),
        isUpdated: state.getIn(['vertical', 'quote', 'form', `summaryPageEdit${path}`])
    };
};

_SummaryOvernightAddress.propTypes = {
    buildingName: PropTypes.string,
    unitType: PropTypes.string,
    unitNumber: PropTypes.string,
    streetNumber: PropTypes.string,
    streetName: PropTypes.string,
    suburb: PropTypes.string,
    ausState: PropTypes.string,
    overnightParkingPostcode: PropTypes.string,
    overnightParkingType: PropTypes.string,
    isUpdated: PropTypes.bool
};

const SummaryOvernightAddress = connect(
    mapStateToProps,
)(_SummaryOvernightAddress);

export { _SummaryOvernightAddress, SummaryOvernightAddress };
